<template>
  <Loading instruction="Finalising Nedbank Direct payment..." />
</template>

<script>
import Loading from '../components/Loading.vue'
import axios from '@/wrapper'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'nedbankFinalisePayment',
  components: {
    Loading,
  },
  async created() {
    await this.finaliseNedbankPayment()
  },
  data() {
    return {
      preHandle: true,
    }
  },
  computed: {
    ...mapState('signalRMessage', ['message']),
    ...mapState('transaction', ['transaction']),
  },
  methods: {
    ...mapActions('signalRMessage', ['setRequest']),

    async finaliseNedbankPayment() {
      const payload = this.$route.query
      await axios
        .post(`bankApi/nedbankPay/ProcessDoPayment`, payload)
        .then((response) => {
          if (!response.data.Success) {
            this.$router.push({
              name: 'cancelled',
              query: { transactionId: response.data.TransactionId },
            })
          }
        })
        .catch(function (error) {
          this.$handleException({ error })
          this.$router.push({
            name: 'cancelled',
          })
        })
    },
  },
}
</script>

<style scoped lang="scss">
.nedbank-pay-auth-wrapper {
  display: grid;
  place-items: center;
  height: 80%;
  padding: 0 20px 20px 20px;

  @media screen and (max-width: $mobile-resolution) {
    padding: 0;
  }
}

.main-wrapper {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 5px 15px rgba(166, 166, 166, 0.3);
  border-radius: 8px;
  position: relative;

  @media screen and (max-width: $mobile-resolution) {
    width: 100%;
    height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
}
</style>
